import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=5c5d706e"
import script from "./SingleChoice.vue?vue&type=script&lang=js"
export * from "./SingleChoice.vue?vue&type=script&lang=js"
import style0 from "./SingleChoice.vue?vue&type=style&index=0&id=5c5d706e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports